/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './editor.all.js';
import './standalone/browser/accessibilityHelp/accessibilityHelp.js';
import './standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js';
import './standalone/browser/inspectTokens/inspectTokens.js';
import './standalone/browser/quickOpen/gotoLine.js';
import './standalone/browser/quickOpen/quickCommand.js';
import './standalone/browser/quickOpen/quickOutline.js';
import './standalone/browser/referenceSearch/standaloneReferenceSearch.js';
import './standalone/browser/toggleHighContrast/toggleHighContrast.js';
export * from './editor.api.js';
